
import React, { useEffect, useState } from 'react'
import { download_app, our_brand_journey, payment_gateway, responsible_gaming, security } from './social_data';
import { CustomHeading } from 'components';
import { svgs } from 'constants';
const SocialFooter = ({ is_live }) => {

    const [loading, setLoading] = useState(false)
    const [social_media, setSocial] = useState(
        [
            {
                "title": "facebook",
                "image": "https:\/\/staticcontentgoldan.s3.ap-south-1.amazonaws.com\/facebook+(1)+1.png",
                "order": 1,
                "status": 1,
                "id": 1,
                "_id": {
                    "$id": "67ad9aa5b6ff513b37233076"
                },
                "link": "",
                "svg": <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2406_16663)">
                        <path d="M35 0H5C2.2425 0 0 2.2425 0 5V35C0 37.7575 2.2425 40 5 40H35C37.7575 40 40 37.7575 40 35V5C40 2.2425 37.7575 0 35 0Z" fill="#1976D2" />
                        <path d="M29.75 20H23.5V15C23.5 13.62 24.62 13.75 26 13.75H28.5V7.5H23.5C19.3575 7.5 16 10.8575 16 15V20H11V26.25H16V40H23.5V26.25H27.25L29.75 20Z" fill="#FAFAFA" />
                    </g>
                    <defs>
                        <clipPath id="clip0_2406_16663">
                            <rect width="40" height="40" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            },
            {
                "title": "Instagram",
                "image": "https:\/\/staticcontentgoldan.s3.ap-south-1.amazonaws.com\/instagram+(3)+1.png",
                "order": 2,
                "status": 1,
                "id": 2,
                "_id": {
                    "$id": "67ad9acdb6ff513b37233078"
                },
                "link": "",
                "svg": <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2406_16669)">
                        <path d="M2.49952 2.72313C-0.643815 5.98813 -0.000481708 9.45646 -0.000481708 19.9931C-0.000481708 28.7431 -1.52715 37.5148 6.46285 39.5798C8.95785 40.2215 31.0645 40.2215 33.5562 39.5765C36.8829 38.7181 39.5895 36.0198 39.9595 31.3148C40.0112 30.6581 40.0112 9.33979 39.9578 8.66979C39.5645 3.65813 36.4795 0.769794 32.4145 0.184794C31.4828 0.0497941 31.2962 0.00979411 26.5162 0.00146078C9.56118 0.00979411 5.84452 -0.745206 2.49952 2.72313Z" fill="url(#paint0_linear_2406_16669)" />
                        <path d="M19.9977 5.233C13.946 5.233 8.19933 4.69467 6.00433 10.328C5.09766 12.6547 5.22933 15.6763 5.22933 20.003C5.22933 23.7997 5.10766 27.368 6.00433 29.6763C8.19433 35.313 13.9877 34.773 19.9943 34.773C25.7893 34.773 31.7643 35.3763 33.986 29.6763C34.8943 27.3263 34.761 24.3497 34.761 20.003C34.761 14.233 35.0793 10.508 32.281 7.71134C29.4477 4.878 25.616 5.233 19.991 5.233H19.9977ZM18.6743 7.89467C31.2977 7.87467 32.9043 6.47134 32.0177 25.9663C31.7027 32.8613 26.4527 32.1047 19.9993 32.1047C8.23266 32.1047 7.89433 31.768 7.89433 19.9963C7.89433 8.088 8.82766 7.90134 18.6743 7.89134V7.89467ZM27.881 10.3463C26.9027 10.3463 26.1093 11.1397 26.1093 12.118C26.1093 13.0963 26.9027 13.8897 27.881 13.8897C28.8593 13.8897 29.6527 13.0963 29.6527 12.118C29.6527 11.1397 28.8593 10.3463 27.881 10.3463ZM19.9977 12.418C15.8093 12.418 12.4143 15.8147 12.4143 20.003C12.4143 24.1913 15.8093 27.5863 19.9977 27.5863C24.186 27.5863 27.5793 24.1913 27.5793 20.003C27.5793 15.8147 24.186 12.418 19.9977 12.418ZM19.9977 15.0797C26.506 15.0797 26.5143 24.9263 19.9977 24.9263C13.491 24.9263 13.481 15.0797 19.9977 15.0797Z" fill="white" />
                    </g>
                    <defs>
                        <linearGradient id="paint0_linear_2406_16669" x1="2.57622" y1="37.4466" x2="39.752" y2="5.27142" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#FFDD55" />
                            <stop offset="0.5" stop-color="#FF543E" />
                            <stop offset="1" stop-color="#C837AB" />
                        </linearGradient>
                        <clipPath id="clip0_2406_16669">
                            <rect width="40" height="40" fill="white" />
                        </clipPath>
                    </defs>
                </svg>

            },
            {
                "title": "Telegram",
                "image": "https:\/\/staticcontentgoldan.s3.ap-south-1.amazonaws.com\/telegram+(3)+1+(1).png",
                "order": 3,
                "status": 1,
                "id": 3,
                "_id": {
                    "$id": "67ad9af7b6ff513b3723307d"
                },
                "link": "",
                "svg":
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_2406_16651)">
                            <path d="M34.5455 0H5.45455C2.44208 0 0 2.44208 0 5.45455V34.5455C0 37.5579 2.44208 40 5.45455 40H34.5455C37.5579 40 40 37.5579 40 34.5455V5.45455C40 2.44208 37.5579 0 34.5455 0Z" fill="#1C8ADB" />
                            <path d="M30.8937 10.3486L30.48 10.4986L8.03003 18.5873C7.87094 18.6365 7.73267 18.7371 7.63689 18.8733C7.54111 19.0095 7.49323 19.1737 7.50077 19.34C7.50831 19.5064 7.57083 19.6655 7.67854 19.7925C7.78625 19.9195 7.93305 20.0072 8.09594 20.0418L13.9073 21.6327L14.9914 24.8146L16.0755 27.9964C16.1378 28.1523 16.2372 28.2908 16.3651 28.3996C16.493 28.5084 16.6455 28.5844 16.8095 28.6209C16.9734 28.6574 17.1438 28.6534 17.3058 28.6091C17.4678 28.5648 17.6165 28.4816 17.7391 28.3668L20.7414 25.5305L26.6368 29.5282C27.3573 30.0191 28.3846 29.6555 28.5687 28.8464L32.4732 11.5941C32.6641 10.7396 31.7641 10.0373 30.8937 10.3486ZM28.0278 14.1782L17.8846 22.4691L17.4073 22.86C17.3025 22.9431 17.234 23.0637 17.2164 23.1964L17.1096 24.0782L16.8164 26.5555C16.8188 26.5856 16.8091 26.6155 16.7895 26.6385C16.7699 26.6615 16.742 26.6758 16.7119 26.6782C16.6817 26.6806 16.6519 26.6709 16.6288 26.6513C16.6058 26.6317 16.5915 26.6038 16.5891 26.5736L15.7641 24.0986L14.9119 21.5646C14.8758 21.4506 14.8806 21.3277 14.9254 21.217C14.9702 21.1062 15.0522 21.0145 15.1573 20.9577L25.7118 14.9077L27.6982 13.7714C27.9868 13.6032 28.2823 13.9691 28.0278 14.1782Z" fill="white" />
                        </g>
                        <defs>
                            <clipPath id="clip0_2406_16651">
                                <rect width="40" height="40" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                ,

            },
            {
                "title": "Twitter",
                "image": "https:\/\/staticcontentgoldan.s3.ap-south-1.amazonaws.com\/Download-Twitter-s-new-X-logo-here-Disobey-02-27-2025_02_34_PM.jpg",
                "order": 4,
                "status": 1,
                "id": 4,
                "_id": {
                    "$id": "67ad9b17b6ff513b3723307f"
                },
                "link": "",
                "svg": <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2406_16666)">
                        <path d="M21.3378 19.3228L30.3392 32.1981H26.645L19.2996 21.6918V21.6911L18.2212 20.1488L9.64062 7.875H13.3348L20.2594 17.7805L21.3378 19.3228Z" fill="black" />
                        <path d="M35.6779 0H4.32209C1.93513 0 0 1.93513 0 4.32209V35.6779C0 38.0649 1.93513 40 4.32209 40H35.6779C38.0649 40 40 38.0649 40 35.6779V4.32209C40 1.93513 38.0649 0 35.6779 0ZM25.5133 33.9208L18.0802 23.1029L8.77392 33.9208H6.3687L17.0122 21.5491L6.3687 6.05868H14.4867L21.5253 16.3025L30.3377 6.05868H32.743L22.5936 17.8566H22.593L33.6313 33.9208H25.5133Z" fill="black" />
                    </g>
                    <defs>
                        <clipPath id="clip0_2406_16666">
                            <rect width="40" height="40" fill="white" />
                        </clipPath>
                    </defs>
                </svg>,
            },
            {
                "title": "Whatsapp",
                "image": "https:\/\/staticcontentgoldan.s3.ap-south-1.amazonaws.com\/whatsapp+(1)+1.png",
                "order": 5,
                "status": 1,
                "id": 5,
                "_id": {
                    "$id": "67ad9b2fb6ff513b37233081"
                },
                "link": "",
                "svg": <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2406_16656)">
                        <path d="M34.5455 0H5.45455C2.44208 0 0 2.44208 0 5.45455V34.5455C0 37.5579 2.44208 40 5.45455 40H34.5455C37.5579 40 40 37.5579 40 34.5455V5.45455C40 2.44208 37.5579 0 34.5455 0Z" fill="#29A71A" />
                        <path d="M28.817 11.184C26.7362 9.08242 23.9728 7.79358 21.0254 7.54998C18.078 7.30637 15.1406 8.12403 12.7429 9.85548C10.3453 11.5869 8.64532 14.1182 7.94961 16.9926C7.25391 19.8671 7.60829 22.8956 8.94883 25.5317L7.63292 31.9204C7.61927 31.984 7.61888 32.0497 7.63178 32.1134C7.64469 32.1772 7.67061 32.2376 7.70792 32.2908C7.76258 32.3717 7.8406 32.4339 7.93157 32.4693C8.02253 32.5046 8.12211 32.5113 8.21701 32.4886L14.4784 31.0045C17.1072 32.3111 20.1142 32.6427 22.9646 31.9402C25.8149 31.2378 28.3235 29.5469 30.0442 27.1685C31.7648 24.79 32.5858 21.8782 32.3611 18.9513C32.1364 16.0243 30.8806 13.272 28.817 11.184ZM26.8647 26.7658C25.425 28.2015 23.5711 29.1492 21.5642 29.4754C19.5573 29.8016 17.4987 29.4898 15.6784 28.584L14.8056 28.1522L10.967 29.0613L10.9784 29.0136L11.7738 25.1499L11.3466 24.3067C10.4165 22.4801 10.0884 20.4059 10.4093 18.3814C10.7301 16.3568 11.6836 14.4858 13.1329 13.0363C14.9541 11.2157 17.4237 10.193 19.9988 10.193C22.5739 10.193 25.0436 11.2157 26.8647 13.0363C26.8802 13.0541 26.897 13.0708 26.9147 13.0863C28.7133 14.9116 29.7174 17.3739 29.708 19.9364C29.6986 22.4989 28.6766 24.9538 26.8647 26.7658Z" fill="white" />
                        <path d="M26.5259 23.9289C26.0555 24.6698 25.3123 25.5766 24.3782 25.8016C22.7418 26.197 20.2305 25.8152 17.1055 22.9016L17.0668 22.8675C14.3191 20.3198 13.6055 18.1993 13.7782 16.5175C13.8736 15.5629 14.6691 14.6993 15.3395 14.1357C15.4455 14.0452 15.5712 13.9808 15.7066 13.9476C15.8419 13.9144 15.9832 13.9133 16.119 13.9445C16.2548 13.9756 16.3815 14.0381 16.4888 14.1269C16.5962 14.2158 16.6813 14.3285 16.7373 14.4561L17.7486 16.7289C17.8144 16.8762 17.8387 17.0387 17.8191 17.1989C17.7995 17.359 17.7366 17.5108 17.6373 17.6379L17.1259 18.3016C17.0162 18.4386 16.95 18.6053 16.9358 18.7803C16.9216 18.9553 16.9601 19.1305 17.0464 19.2834C17.3327 19.7857 18.0191 20.5243 18.7805 21.2084C19.635 21.9811 20.5827 22.6879 21.1827 22.9289C21.3433 22.9944 21.5198 23.0104 21.6895 22.9748C21.8592 22.9392 22.0144 22.8535 22.135 22.7289L22.7282 22.1311C22.8426 22.0183 22.985 21.9378 23.1407 21.8978C23.2964 21.8579 23.4599 21.86 23.6145 21.9039L26.0168 22.5857C26.1493 22.6263 26.2708 22.6967 26.3719 22.7915C26.4731 22.8863 26.5512 23.003 26.6003 23.1326C26.6494 23.2622 26.6683 23.4013 26.6554 23.5393C26.6425 23.6774 26.5982 23.8106 26.5259 23.9289Z" fill="white" />
                    </g>
                    <defs>
                        <clipPath id="clip0_2406_16656">
                            <rect width="40" height="40" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            },
            {
                "title": "Youtube",
                "image": "https:\/\/staticcontentgoldan.s3.ap-south-1.amazonaws.com\/youtube-svgrepo-com+1.png",
                "order": 6,
                "status": 1,
                "id": 6,
                "_id": {
                    "$id": "67ad9b59b6ff513b37233083"
                },
                "link": "",
                "svg": <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2406_16672)">
                        <path d="M34 0H6C2.68629 0 0 2.68629 0 6V34C0 37.3137 2.68629 40 6 40H34C37.3137 40 40 37.3137 40 34V6C40 2.68629 37.3137 0 34 0Z" fill="#ED1D24" />
                        <path d="M33.4689 13.0427C33.1542 11.8457 32.1314 10.8882 30.9512 10.569C28.2762 9.85077 12.1471 9.77097 9.07867 10.569C7.8985 10.8882 6.87568 11.8457 6.56097 13.0427C5.85287 16.0751 5.77419 23.8156 6.56097 26.9277C6.87568 28.1247 7.8985 29.0823 9.07867 29.4015C11.9111 30.1995 28.0401 30.1995 30.9512 29.4015C32.1314 29.0823 33.1542 28.1247 33.4689 26.9277C34.177 24.055 34.177 15.9953 33.4689 13.0427Z" fill="white" />
                        <path d="M17 16V23.619L24.619 19.8095" fill="#ED1D24" />
                    </g>
                    <defs>
                        <clipPath id="clip0_2406_16672">
                            <rect width="40" height="40" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            }
        ])


    return (
        <React.Fragment>
            <CustomHeading svg={svgs.security_lock} text={"Security & Services"} down_icon={false} redirect={false} type={3} />
            <CustomHeading svg={false} text={"Our Brand Journey"} down_icon={false} redirect={false} type={2} />
            <div className='my-2 flex justify-between items-center px-2'>
                {our_brand_journey.map((item, index) => (
                    <div key={index}>{item.svg}</div>
                ))}
            </div>

            {!is_live &&
                <React.Fragment>
                    <CustomHeading svg={svgs.rs_gaming_svg} text={"Responsible Gaming"} down_icon={false} redirect={false} type={2} />
                    <div className='my-2 flex justify-between items-center px-2'>
                        {responsible_gaming.map((item, index) => (
                            <div key={index}>
                                {item.svg ? item.svg : <img src={item.image} loading="lazy" alt="responsible gaming icon" />}
                            </div>
                        ))}

                    </div>

                    <CustomHeading svg={svgs.cards} text={"Payment Gateway"} down_icon={false} redirect={false} type={2} />
                    <div className='my-2 flex justify-between items-center px-2'>

                        {payment_gateway.map((item, index) => (
                            <div key={index}>
                                {item.svg ? item.svg : <img src={item.image} loading="lazy" alt="payment gateway" />}
                            </div>
                        ))}
                    </div>

                    <CustomHeading svg={svgs.social_media} text={"Social Media"} down_icon={false} redirect={false} type={2} />
                    <div className='my-2 flex justify-between items-center px-2'>
                        {social_media && social_media.length > 0 &&
                            social_media.map((item, index) =>
                                item.status === 1 && (
                                    <React.Fragment key={index}>
                                        {item.link ? (
                                            <a href={item.link} target="_blank" rel="noopener noreferrer">
                                                {item.svg}
                                                {/* <img src={item.image} height={40} width={40} alt="social media icon" loading="lazy" /> */}
                                            </a>
                                        ) : (
                                            item.svg
                                            // <img src={item.image} height={40} width={40} alt="social media icon" loading="lazy" />
                                        )}
                                    </React.Fragment>
                                )
                            )
                        }

                    </div>

                    <CustomHeading svg={svgs.security_lock_2} text={"Security"} down_icon={false} redirect={false} type={2} />
                    <div className='my-2 flex justify-between items-center px-2'>
                        {security.map((item, index) => (
                            <div key={index}>
                                {item.svg ? item.svg : <img src={item.image} loading="lazy" alt="security icon" />}
                            </div>
                        ))}
                    </div>

                    <CustomHeading svg={svgs.mobile} text={"Download Application"} down_icon={false} redirect={false} type={2} />
                    <div className='my-2 flex justify-around items-center px-2'>
                        {download_app.map((item, index) => (
                            <div key={index}>
                                {item.svg ? item.svg : <img src={item.image} loading="lazy" alt="download app icon" />}
                            </div>
                        ))}

                    </div>

                </React.Fragment>}

        </React.Fragment>

    )
}

export default SocialFooter